export default "/assets/images/mila-air-au-lg.b526c243132bb6d1.png";